/**
 * Generated from TrashCollectIntroLayout.fla
 */
export function TrashCollectIntroLayout(this: ITrashCollectIntroLayout) {
	const bg = this.bg;
	TrashCollectIntroLayout_bg.call(this.bg);
	bg.x = 375.6;
	bg.y = 459.95;
	bg.width = 2462.64;
	bg.height = 1136.58;
	if (bg.onLayout) bg.onLayout();
	const homeButton = this.homeButton;
	TrashCollectIntroLayout_homeButton.call(this.homeButton);
	homeButton.x = 108;
	homeButton.y = 164.5;
	homeButton.width = 146.00;
	homeButton.height = 151.00;
	if (homeButton.onLayout) homeButton.onLayout();
	const grover = this.grover;
	TrashCollectIntroLayout_grover.call(this.grover);
	grover.x = 740.2;
	grover.y = 626.15;
	grover.width = 226.82;
	grover.height = 457.93;
	if (grover.onLayout) grover.onLayout();
	const oscar = this.oscar;
	TrashCollectIntroLayout_oscar.call(this.oscar);
	oscar.x = 324.7;
	oscar.y = 629.8;
	oscar.width = 219.60;
	oscar.height = 398.99;
	if (oscar.onLayout) oscar.onLayout();
	const skipButton = this.skipButton;
	TrashCollectIntroLayout_skipButton.call(this.skipButton);
	skipButton.x = 946.25;
	skipButton.y = 687.75;
	skipButton.width = 156.50;
	skipButton.height = 161.50;
	if (skipButton.onLayout) skipButton.onLayout();
	return this;
}
function TrashCollectIntroLayout_bg(this: ITrashCollectIntroLayout_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("bg.png", 0.281, 0.681);
	return this;
}
function TrashCollectIntroLayout_homeButton(this: ITrashCollectIntroLayout_homeButton) {
	if (this.setLayoutTexture) this.setLayoutTexture("home-btn.png", 0.500, 0.500);
	return this;
}
function TrashCollectIntroLayout_grover(this: ITrashCollectIntroLayout_grover) {
	if (this.setLayoutTexture) this.setLayoutTexture("Grover-wave.png", 0.531, 0.972);
	return this;
}
function TrashCollectIntroLayout_oscar(this: ITrashCollectIntroLayout_oscar) {
	if (this.setLayoutTexture) this.setLayoutTexture("Oscar-3.png", 0.503, 0.980);
	return this;
}
function TrashCollectIntroLayout_skipButton(this: ITrashCollectIntroLayout_skipButton) {
	if (this.setLayoutTexture) this.setLayoutTexture("skip-btn.png", 0.500, 0.500);
	return this;
}
interface ITrashCollectIntroLayoutArray<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface ITrashCollectIntroLayoutContainer {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface ITrashCollectIntroLayoutSprite extends ITrashCollectIntroLayoutContainer {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface ITrashCollectIntroLayoutText extends ITrashCollectIntroLayoutContainer {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface ITrashCollectIntroLayoutPolygon extends Array<number> {
}
interface ITrashCollectIntroLayout {
	readonly bg: ITrashCollectIntroLayout_bg;
	readonly homeButton: ITrashCollectIntroLayout_homeButton;
	readonly grover: ITrashCollectIntroLayout_grover;
	readonly oscar: ITrashCollectIntroLayout_oscar;
	readonly skipButton: ITrashCollectIntroLayout_skipButton;
}
interface ITrashCollectIntroLayout_bg extends ITrashCollectIntroLayoutSprite {
}
interface ITrashCollectIntroLayout_homeButton extends ITrashCollectIntroLayoutSprite {
}
interface ITrashCollectIntroLayout_grover extends ITrashCollectIntroLayoutSprite {
}
interface ITrashCollectIntroLayout_oscar extends ITrashCollectIntroLayoutSprite {
}
interface ITrashCollectIntroLayout_skipButton extends ITrashCollectIntroLayoutSprite {
}
